/**
 * Determines the registration type based on current user and easy join data
 * @param {Object} currentUser - Current user object from Redux state
 * @param {Object} easyJoinData - Easy join data from Redux state
 * @returns {string} - Registration type: 'EASY_JOIN',
 * 'EXISTING_ACCOUNT', 'EXISTING_PRIMARY_ADMIN'
 */

const getRegistrationType = (currentUser, easyJoinData) => {
  if (easyJoinData && easyJoinData.easyJoinId) {
    return 'EASY_JOIN';
  }

  // Existing primary admin check
  if (currentUser && currentUser.id) {
    if (currentUser.primaryAdmin === 1) {
      return 'EXISTING_PRIMARY_ADMIN';
    }
    return 'EXISTING_ACCOUNT';
  }

  return null;
};

export default getRegistrationType;
